import { Component } from '@angular/core';
import {
  ORG_UNIT_NOTIFIER,
  ORG_UNIT_SERVICE
} from '@nucleus/org-unit-ui';
import {
  TasksenseOrgUnitNotifierAdapter,
  TasksenseOrgUnitServiceAdapter
} from './org-units.adapter';

/**
 * NUC-NNN (mirror of GOLD-89 / NUC-267): tasksense thin shell. Heavy lifting
 * (tabs + table + dialog) lives in `<lib-org-units>` from @nucleus/org-unit-ui.
 * This component just registers the tenant adapters via DI providers.
 * Access is gated by the shared CAPABILITY_CHECKER (wired app-wide to
 * PermissionsService) — the lib resolves OrgUnitCaps codes itself.
 */
@Component({
  selector: 'org-units',
  templateUrl: './org-units.component.html',
  styleUrl: './org-units.component.css',
  standalone: false,
  providers: [
    { provide: ORG_UNIT_SERVICE,     useExisting: TasksenseOrgUnitServiceAdapter },
    { provide: ORG_UNIT_NOTIFIER,    useClass:    TasksenseOrgUnitNotifierAdapter },
  ]
})
export class OrgUnitsComponent { }
